import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { DeviceCheckService } from "src/app/core/survey/shared/services/device-check.service";
import { Address } from "src/app/shared/Models/Address";
import { AddressTypeEnum } from "src/app/shared/Models/enums/AddressTypeEnum";
import { Building } from "src/app/shared/Models/read";

@Component({
  selector: "app-inside-survey-address-info-form",
  templateUrl: "./inside-survey-address-info-form.component.html",
  styleUrls: ["./inside-survey-address-info-form.component.scss"],
})
export class InsideSurveyAddressInfoFormComponent implements OnInit {
  @Input() building: Building;
  @Input() buildingIndex: number;
  @Input() index: number;
  @Input() buildingKey: number | null;
  @Input() isAuthCanWrite: boolean;
  @Output() mainAddressUpdated = new EventEmitter<string>();
  mainAddressId: string;

  inPortrait: boolean;

  constructor(private deviceCheckService: DeviceCheckService) {}

  ngOnInit(): void {
    this.mainAddressId = this.building.getMainAddress()?.id;
    this.inPortrait = this.deviceCheckService.onPortrait();
  }

  @HostListener("window:resize")
  onResize() {
    this.inPortrait = this.deviceCheckService.onPortrait();
  }

  public onAddressChecked(address: Address) {
    this.mainAddressId = address.id;
    this.mainAddressUpdated.emit(address.id);
  }

  canChangeMainAddress(address: Address) {
    return (
      this.mainAddressId !== address.id &&
      this.isAuthCanWrite &&
      this.checkAddressInUse(address)
    );
  }

  public checkAddressInUse(address: Address) {
    if (
      this.building.addresses.every(
        (a) => a.addressType === AddressTypeEnum.NotInUse
      )
    )
      return true;
    if (address.addressType === AddressTypeEnum.NotInUse) return false;
    return true;
  }
}
